const state = {
    petInfo: {},
    petBreed: {},
  }
  
  const mutations = {
    SET_PETINFO: (state, petInfo) => {
      sessionStorage.setItem('addPetInfo', JSON.stringify(petInfo))
      state.petInfo = petInfo
    },
    SET_PETBREED: (state, petBreed) => {
      sessionStorage.setItem('petBreed', JSON.stringify(petBreed))
      state.petBreed = petBreed
    },
  }
  
  const actions = {
   
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  